import React, { Fragment } from "react";

import RedLogo from "../Mentors/RedLogo";

const CancelSubscriptionConfirm = ({
  user,
  canceledsubscription,
  setshowCancelSubscription,
  profile: { avatar, firstname, lastname, jobtitle, location },
}) => {
  return (
    <Fragment>
      {canceledsubscription && canceledsubscription.status === "canceled" && (
        <div className="subscription-overlay">
          <div className="subscription-box-confirmation">
            <i
              className="far fa-times-circle red fa-3x subscription-x"
              onClick={() =>
                setshowCancelSubscription({ request: false, confirm: false })
              }
            ></i>
            <div className="subscription-type-container">
              <p className="nav-logo">
                <RedLogo />
              </p>
              <h1 className="subscription-name red">
                Monthly Subscription Canceled
              </h1>
            </div>
            <div className="sub-grid-three">
              <div className="sub-container">
                <div className="sub-user">
                  <div className="online-avi-container">
                    <div className="avi-color-border-alt red">
                      <img
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                        className="sub-avi"
                        alt="avatar"
                      />
                    </div>
                  </div>
                  <div className="online-info">
                    <ul className="user-online-items">
                      <li className="user-online-item">
                        <span className="red name-font bold">
                          {firstname} {lastname}
                        </span>
                      </li>
                      <li className="user-online-item">{jobtitle}</li>
                      <li className="user-online-item">
                        {location.city}, {location.state}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="subscription-user">
                <div className="sub-section-container">
                  <div className="flex-only">
                    <i className="fas fa-user-circle mr-5 fa-lg mt-5 red"></i>
                    <p className="sub-section red">Subscription canceled:</p>
                  </div>
                </div>
                <div className="sub-user">
                  <div className="online-avi-container">
                    <div className="avi-color-border-alt red">
                      <img
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                        className="sub-avi"
                        alt="avi-two"
                      />
                    </div>
                  </div>
                  <div className="sub-info">
                    <ul className="user-online-items">
                      <li className="user-online-item">
                        <span className="red name-font bold">
                          {user.firstname} {user.lastname}
                        </span>
                      </li>
                      <li className="user-online-item">{user.jobtitle}</li>
                      <li className="user-online-item">
                        {user.location.city}, {user.location.state}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="sub-grid">
              <p className="user-request-text">
                Your recurring monthly subscription to
                {firstname} {lastname}
                has successfully been canceled.
              </p>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default CancelSubscriptionConfirm;
